<template>
    <form class="h-full w-full flex flex-col p-8">
        <transition name="rsdfade" mode="out-in">
            <div key="1" ref="tab1" v-if="selectedTab == 1" class="flex flex-col">
                <div class="grid grid-cols-3 gap-6">
                    <div class="flex flex-col form-input" :class="{ invalid: !groupName.isValid }">
                        <label for="groupName">Name of Group</label>
                        <input
                            type="text"
                            id="groupName"
                            v-model.trim="groupName.val"
                            placeholder=""
                            @blur="clearValidity('groupName')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!groupName.isValid" class="h-4 text-xs text-red-600">
                                {{ groupName.msg }}
                            </p>
                        </transition>
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !trainingEntity.isValid }">
                        <label for="trainingEntity">Training Entity</label>
                        <select class="ht-42" id="trainingEntity" v-model.trim="trainingEntity.val" placeholder="" @change="onTrainingEntityChange" @blur="clearValidity('trainingEntity')">
                            <option value="">Select an option</option>
                            <option v-for="(partner, index) in getAllPartners" :key="index" :value="partner.id">{{ partner.en_company_name }}</option>
                        </select>
                        <transition name="fade" mode="out-in">
                            <p v-if="!trainingEntity.isValid" class="h-4 text-xs text-red-600">
                                {{ trainingEntity.msg }}
                            </p>
                        </transition>
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !fieldOfTraining.isValid }">
                        <label for="fieldOfTraining">Field of Training</label>
                        <input
                            type="text"
                            id="fieldOfTraining"
                            v-model.trim="fieldOfTraining.val"
                            placeholder=""
                            @blur="clearValidity('fieldOfTraining')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!fieldOfTraining.isValid" class="h-4 text-xs text-red-600">
                                {{ fieldOfTraining.msg }}
                            </p>
                        </transition>
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !sector.isValid }">
                        <label for="sector">Sector</label>
                        <input
                            type="text"
                            id="sector"
                            v-model.trim="sector.val"
                            disabled
                        />
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !location.isValid }">
                        <label for="location">Location</label>
                        <input
                            type="text"
                            id="location"
                            v-model.trim="location.val"
                            disabled
                        />
                    </div>
                    <div v-if="sector.val == 'Private' || sector.val == 'Semi-Government'" class="flex flex-col form-input" :class="{ invalid: !location.isValid }">
                        <label for="location">Trade License Authority</label>
                        <input
                            type="text"
                            id="trade_license_authority"
                            v-model.trim="trade_license_authority.val"
                            disabled
                        />
                    </div>
                    <div v-if="sector.val == 'Private' || sector.val == 'Semi-Government'" class="flex flex-col form-input" :class="{ invalid: !location.isValid }">
                        <label for="location">Trade License Number</label>
                        <input
                            type="text"
                            id="trade_license_number"
                            v-model.trim="trade_license_number.val"
                            disabled
                        />
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !startDate.isValid }">
                        <label for="startDate">Start Date</label>
                        <date-picker
                            v-model:value="startDate.val"
                            format="YYYY-MM-DD"
                            type="date"
                            value-type="format"
                            :default-value="new Date()"
                            :disabled-date="getDisabledDates"
                            placeholder="Select Start Date"
                        ></date-picker>
                        <transition name="fade" mode="out-in">
                            <p v-if="!startDate.isValid" class="h-4 text-xs text-red-600">
                                {{ startDate.msg }}
                            </p>
                        </transition>
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !endDate.isValid }">
                        <label for="endDate">End Date</label>
                        <date-picker
                            v-model:value="endDate.val"
                            format="YYYY-MM-DD"
                            type="date"
                            value-type="format"
                            :default-value="new Date()"
                            :disabled-date="getDisabledDates"
                            placeholder="Select End Date"
                        ></date-picker>
                        <transition name="fade" mode="out-in">
                            <p v-if="!endDate.isValid" class="h-4 text-xs text-red-600">
                                {{ endDate.msg }}
                            </p>
                        </transition>
                    </div>
                    <div class="flex flex-col form-input" :class="{ invalid: !supervisor.isValid }">
                        <label for="supervisor">Supervisor</label>
                        <input
                            type="text"
                            id="supervisor"
                            v-model.trim="supervisor.val"
                            placeholder=""
                            @blur="clearValidity('supervisor')"
                        />
                        <transition name="fade" mode="out-in">
                            <p v-if="!supervisor.isValid" class="h-4 text-xs text-red-600">
                                {{ supervisor.msg }}
                            </p>
                        </transition>
                    </div>
                </div>

                <div class="flex flex-col mt-6">
                    <div class="grid grid-cols-3 gap-6">
                        <div class="flex flex-col form-input" :class="{ invalid: !school.isValid }">
                            <label for="school">School</label>
                            <select class="ht-42" v-model.trim="school.val" id="school" @change="onSchoolChange" @blur="clearValidity('school')">
                                <option value="">Select a school</option>
                                <option v-for="(fc, index) in fetchSchools" :key="index" :value="fc">{{ fc }}</option>
                            </select>
                            <transition name="fade" mode="out-in">
                                <p v-if="!school.isValid" class="h-4 text-xs text-red-600">
                                    {{ school.msg }}
                                </p>
                            </transition>
                        </div>
                        <div class="flex flex-col form-input" :class="{ invalid: !grade.isValid }">
                            <label for="grade">Grade</label>
                            <select class="ht-42" v-model.trim="grade.val" id="grade" @change="onGradeChange" @blur="clearValidity('grade')">
                                <option value="">Select a grade</option>
                                <option v-for="(g, index) in grades" :key="index" :value="g">{{ g }}</option>
                            </select>
                            <transition name="fade" mode="out-in">
                                <p v-if="!grade.isValid" class="h-4 text-xs text-red-600">
                                    {{ grade.msg }}
                                </p>
                            </transition>
                        </div>
                        <div class="flex flex-col form-input" :class="{ invalid: !grade.isValid }">
                            <label for="grade">Classroom</label>
                            <select class="ht-42" v-model.trim="homeroom.val" id="homeroom" @change="onHomeroomChange" @blur="clearValidity('homeroom')">
                                <option value="">Select a Classroom</option>
                                <option v-for="(hr, index) in homerooms" :key="index" :value="hr">{{ hr }}</option>
                            </select>
                            <transition name="fade" mode="out-in">
                                <p v-if="!homeroom.isValid" class="h-4 text-xs text-red-600">
                                    {{ homeroom.msg }}
                                </p>
                            </transition>
                        </div>
                    </div>

                    <div class="mt-6 flex flex-col">
                        <div class="flex justify-between items-center flex-wrap">
                            <div class="flex justify-start items-center">
                                <label for="select-students">Select Students</label>
                                <div class="ml-1 mb-1 text-xs" v-if="selectedCandidates.length > 0">{{ getSelectedStudentsText }}</div>
                            </div>
                            <div v-if="filteredStudents.length > 0" class="flex">
                                <div v-if="isSelectAllBtnClicked && selectedCandidates.length > 0" class="text-sm cursor-pointer hover:text-blue-600 hover:underline" @click.stop="unselectAllStudents">Unselect All</div>
                                <div v-else class="text-sm cursor-pointer hover:text-blue-600 hover:underline" @click.stop="selectAllStudents">Select All</div>
                            </div>
                        </div>
                        <div class="flex flex-col border min-ht-44 rounded-t-md" :class="showDropDown ? '' : 'rounded-b-md'">
                            <div>
                                <input v-model="search" type="text" placeholder="Type to search" class="w-full rounded-t-md rounded-b-md p-2 outline-none" @focus="showDropDown = true">
                            </div>
                            <!-- <div v-if="selectedCandidates.length > 0" class="flex justify-start flex-wrap p-2 max-ht-224 overflow-y-auto">
                                <div v-for="(item, index) in selectedCandidates" :key="index" class="flex items-center bg-green-600 px-2 py-1 rounded-md mr-2 mb-2">
                                    <div class="text-white text-sm">{{ item.fullname }}</div>
                                    <div class="ml-2">
                                        <svg @click.stop="removeCandidate(item.student_id)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="4" stroke="currentColor" class="w-3 h-3 text-gray-600 hover:text-white cursor-pointer">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div v-if="showDropDown" class="h-56 border border-t-0 rounded-b-md overflow-y-auto">
                            <div v-for="(item, index) in filteredStudents" :key="index" :class="item.is_selected ? 'bg-green-600 cursor-not-allowed' : selectedCandidates.length > 0 ? 'bg-red-600 cursor-pointer' : 'cursor-pointer'" class="px-4 py-2 hover:bg-gray-600 hover:text-white" @click.stop="addCandidate(item)">
                                <div class="flex justify-between items-center">
                                    <div>{{ item.fullname }} - {{ item.student_id }}</div>
                                    <div class="flex-shrink-0 flex justify-start items-center">
                                        <div v-if="item.is_selected" class="ml-4">
                                            <icon-close @click.stop="removeCandidate(item.student_id)" class="w-4 h-4 text-red-600 transform hover:scale-110 cursor-pointer"></icon-close>
                                        </div>
                                        <div class="ml-4">
                                            <icon-eye @click.stop="viewStudentProfile(item.student_id)" class="w-4 h-4 transform hover:scale-110 cursor-pointer"></icon-eye>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <transition name="fade" mode="out-in">
                            <p v-if="!selectedCandidatesIsValid" class="h-4 text-xs text-red-600">
                                {{ selectedCandidatesIsValidMsg }}
                            </p>
                        </transition>
                    </div>
                </div>
            </div>
            <div key="2" v-else class="flex flex-col" :style="getStyle">
                <div @click.stop="selectedTab = 1" class="h-8 w-8 border-2 rounded-full flex items-center justify-center border-black cursor-pointer">
                    <icon-back class="w-6 h-6 transform hover:scale-110 cursor-pointer"></icon-back>
                </div>
                <div class="flex-auto flex flex-col overflow-y-auto mt-4">
                    <div class="text-gray-600 text-xl font-medium">Unselected Students</div>
                    <div class="flex flex-col">
                        <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                                <div class="overflow-hidden">
                                    <table class="min-w-full border text-center text-sm font-light">
                                        <thead class="border-b font-medium bg-primary text-white">
                                            <tr>
                                                <th
                                                    scope="col"
                                                    class="border-r px-6 py-4">
                                                    #
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="border-r px-6 py-4">
                                                    Student Name
                                                </th>
                                                <th scope="col" class="px-6 py-4">Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in unSelectedCandidates" :key="index" class="border-b">
                                                <td class="whitespace-nowrap border-r px-6 py-4 font-medium">
                                                    {{ index + 1 }}
                                                </td>
                                                <td class="whitespace-nowrap border-r px-6 py-4">
                                                    {{ item.fullname }}
                                                </td>
                                                <td class="whitespace-nowrap border-r px-6 py-4">
                                                    <textarea v-model="item.reason" placeholder="Enter the reason" class="resize-none w-full h-full outline-none text-sm"></textarea>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition name="fade" mode="out-in">
                        <p v-if="!unSelectedStudentReasonIsValid" class="h-4 text-xs text-red-600">
                            {{ unSelectedStudentReasonMsg }}
                        </p>
                    </transition>
                </div>

                
            </div>
        </transition>

        <div class="w-full flex justify-center mt-8">
            <div v-if="isLoading" class="bg-gradient-to-r from-primary to-secondaryLight px-4 py-2 rounded-lg text-white flex items-center justify-center">
                <base-spinner-with-text class-list="h-6 w-6 text-white capitalize" :text="getLoadingBtnText" text-class-list="text-white"></base-spinner-with-text>
            </div>
            <button v-else type="button" class="bg-gradient-to-r from-primary to-secondaryLight px-4 py-2 rounded-lg text-white" @click.stop="addAndReview">{{ getBtnText }}</button>
        </div>
    </form>
</template>

<script>
import gql from 'graphql-tag';
import IconEye from "../../components/icons/IconEye.vue";
import IconClose from "../../components/icons/IconClose.vue";
import IconBack from "../../components/icons/IconBack.vue";
export default {
    name: "internship-form",
    emits: ["created", "updated", "close", "view-student-profile", "review"],
    props: ["mode", "selectedItem", "candidates", "getAllPartners", "getAcademicYearTerms"],
    components: {
        IconEye,
        IconClose,
        IconBack,
    },
    data() {
        return {
            // getAllPartners: [],
            groupName: {
                val: "",
                isValid: true,
                msg: "",
            },
            trainingEntity: {
                val: "",
                isValid: true,
                msg: "",
            },
            trainingEntityName: "",
            startDate: {
                val: "",
                isValid: true,
                msg: "",
            },
            endDate: {
                val: "",
                isValid: true,
                msg: "",
            },
            fieldOfTraining: {
                val: "",
                isValid: true,
                msg: "",
            },
            supervisor: {
                val: "",
                isValid: true,
                msg: "",
            },
            school: {
                val: "",
                isValid: true,
                msg: "",
            },
            grade: {
                val: "",
                isValid: true,
                msg: "",
            },
            homeroom: {
                val: "",
                isValid: true,
                msg: "",
            },
            sector: {
                val: "",
                isValid: true,
                msg: "",
            },
            location: {
                val: "",
                isValid: true,
                msg: "",
            },
            trade_license_authority: {
                val: "",
                isValid: true,
                msg: "",
            },
            trade_license_number: {
                val: "",
                isValid: true,
                msg: "",
            },
            formIsValid: true,
            isLoading: false,
            error: null,
            fetchSchools: [],
            grades: [],
            homerooms: [],
            students: [],
            showDropDown: false,
            search: "",
            selectedCandidates: [],
            selectedCandidatesIsValid: true,
            selectedCandidatesIsValidMsg: "",
            isSelectAllBtnClicked: false,
            markSelectedCandidates: false,
            minDate: new Date().toISOString().slice(0, 16),
            unSelectedCandidates: [],
            selectedTab: 1,
            unSelectedStudentReasonIsValid: true,
            unSelectedStudentReasonMsg: "",
        };
    },
    created() {
        if (this.mode == 'edit') {
            this.setFormData();
        }
    },
    watch: {
        'school.val': function(newVal) {
            this.fetchGrades(newVal);
        },
        'grade.val': function(newVal) {
            this.fetchHomerooms(newVal);
        },
        'homeroom.val': function(newVal) {
            this.fetchStudents(newVal);
        },
        selectedCandidates() {
            this.selectedCandidatesIsValid = true;
            this.selectedCandidatesIsValidMsg = "";
        },
    },
    computed: {
        getBtnText() {
            if (this.mode == 'create') {
                return "Review & Create";
            } else {
                return "Review & Update";
            }
        },
        getLoadingBtnText() {
            if (this.mode == 'create') {
                return "Creating...";
            } else {
                return "Updating...";
            }
        },
        filteredStudents() {
            return this.students.filter(user =>
                user.fullname.toLowerCase().includes(this.search.toLowerCase())
            );
        },
        getSelectedStudentsText() {
            if (this.selectedCandidates.length > 1) {
                return `(${this.selectedCandidates.length}/${this.students.length} students selected)`;
            } else {
                return `(${this.selectedCandidates.length}/${this.students.length} student selected)`;
            }
        },
        getStyle() {
            const divElement = this.$refs.tab1;
            if (divElement) {
                const divHeight = divElement.clientHeight;
                return `height: ${divHeight}px;`;
            } else {
                return "height: 659px;";
            }
        },
    },
    apollo: {
        fetchSchools() {
            return {
                query: gql`query GetSchoolList {
                    fetchSchools
                }`,
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        clearValidity(input) {
            this[input].isValid = true;
            this[input].msg = "";
        },
        validateForm1() {
            this.formIsValid = true;
            
            if (this.groupName.val === "") {
                this.groupName.isValid = false;
                this.groupName.msg = "Group Name must not be empty.";
                this.formIsValid = false;
            }
            if (this.trainingEntity.val === "") {
                this.trainingEntity.isValid = false;
                this.trainingEntity.msg = "You must select a Training Entity.";
                this.formIsValid = false;
            }
            if (this.fieldOfTraining.val === "") {
                this.fieldOfTraining.isValid = false;
                this.fieldOfTraining.msg = "Field of Training must not be empty.";
                this.formIsValid = false;
            }
            if (this.supervisor.val === "") {
                this.supervisor.isValid = false;
                this.supervisor.msg = "Supervisor must not be empty.";
                this.formIsValid = false;
            }
            if (this.startDate.val === "") {
                this.startDate.isValid = false;
                this.startDate.msg = "Start Date & Time must not be empty.";
                this.formIsValid = false;
            }
            if (this.endDate.val === "") {
                this.endDate.isValid = false;
                this.endDate.msg = "End Date & Time must not be empty.";
                this.formIsValid = false;
            }
            if (this.school.val === "") {
                this.school.isValid = false;
                this.school.msg = "You must select a school.";
                this.formIsValid = false;
            }
            if (this.grade.val === "") {
                this.grade.isValid = false;
                this.grade.msg = "You must select a grade.";
                this.formIsValid = false;
            }
            if (this.homeroom.val === "") {
                this.homeroom.isValid = false;
                this.homeroom.msg = "You must select a classroom.";
                this.formIsValid = false;
            }
            if (this.selectedCandidates.length == 0) {
                this.selectedCandidatesIsValid = false;
                this.selectedCandidatesIsValidMsg = "You must select atleast 1 candidate";
                this.formIsValid = false;
            }
            if (this.sector.val === "") {
                this.sector.isValid = false;
                this.sector.msg = "You must select a sector.";
                this.formIsValid = false;
            }
            if (this.location.val === "") {
                this.location.isValid = false;
                this.location.msg = "You must select a location.";
                this.formIsValid = false;
            }
            
        },
        validateForm2() {
            this.formIsValid = true;
            this.unSelectedStudentReasonIsValid = true;
            this.unSelectedStudentReasonMsg = "";
            for (const item of this.unSelectedCandidates) {
                const reasonIsBlank = item.reason == "";
                if (reasonIsBlank) {
                    this.formIsValid = false;
                    this.unSelectedStudentReasonIsValid = false;
                    this.unSelectedStudentReasonMsg = "Please add the reason why you are not selected these students";
                    break;
                }
            }
        },
        addAndReview() {
            this.validateForm1();
            
            if (!this.formIsValid) {
                return;
            }

            if (this.checkUnSelected()) {
                if (this.selectedTab == 1) {
                    this.selectedTab = 2;
                } else {
                    this.validateForm2();
                    if (!this.formIsValid) {
                        return;
                    }
                    this.confirmSubmit();
                    this.selectedTab = 1;
                }
            } else {
                this.confirmSubmit();
            }
        },
        confirmSubmit() {
            const formData = {
                group_name: this.groupName.val,
                partner_id: parseInt(this.trainingEntity.val),
                field_of_training: this.fieldOfTraining.val,
                supervisor: this.supervisor.val,
                start_date: this.startDate.val + " 00:00:00",
                end_date: this.endDate.val + " 23:59:59",
                school_id: this.school.val,
                grade: parseInt(this.grade.val),
                homeroom: this.homeroom.val,
                selected_candidates: this.selectedCandidates,
                un_selected_candidates: this.unSelectedCandidates,
                partner_company_name: this.trainingEntityName,
                sector: this.sector.val,
                location: this.location.val,
                trade_license_authority: this.trade_license_authority.val,
                trade_license_number: this.trade_license_number.val,
                training_document: null,
            };

            if (this.mode == 'edit') {
                formData.ref_no = this.selectedItem.ref_no;
            }

            this.$emit('review', formData);
        },
        checkUnSelected() {
            return this.unSelectedCandidates.length > 0;
        },
        setFormData() {
            this.groupName.val = this.selectedItem.group_name;
            this.trainingEntity.val = this.selectedItem.partner.id;
            this.fieldOfTraining.val = this.selectedItem.field_of_training;
            this.supervisor.val = this.selectedItem.supervisor;
            this.startDate.val = this.selectedItem.start_date.split(' ')[0];
            this.endDate.val = this.selectedItem.end_date.split(' ')[0];
            this.school.val = this.selectedItem.school_id;
            this.grade.val = parseInt(this.selectedItem.grade);
            this.homeroom.val = this.selectedItem.homeroom;
            this.selectedCandidates = this.selectedItem.internship_candidates.map(item => ({
                student_id: item.student_id,
                fullname: item.student.name_en
            }));
            this.unSelectedCandidates = this.selectedItem.internship_unselected_candidates.map(item => ({
                student_id: item.student_id,
                fullname: item.student.name_en,
                reason: item.reason,
            }));
            this.markSelectedCandidates = true;
            this.onTrainingEntityChange();
        },
        onSchoolChange() {
            this.grade = {
                val: "",
                isValid: true,
                msg: "",
            };
            this.grades = [];
            this.onGradeChange();
        },
        onGradeChange() {
            this.homeroom = {
                val: "",
                isValid: true,
                msg: "",
            };
            this.homerooms = [];
            this.onHomeroomChange();
        },
        onHomeroomChange() {
            this.unSelectedCandidates = [];
            this.selectedCandidates = [];
            this.students = [];
            this.markSelectedCandidates = false;
        },
        async fetchGrades(schoolId) {
            if (schoolId) {
                try {

                    const { data } = await this.$apollo.query({
                        query: gql`
                            query FetchGrades($school_id: String!) {
                                fetchGrades(school_id: $school_id)
                            }
                        `,
                        variables: {
                            school_id: 'ATHS-' + schoolId,
                        },
                        fetchPolicy: 'network-only',
                    });

                    this.grades = data.fetchGrades;

                } catch (error) {
                    console.log(error.message);
                }
            }
        },
        async fetchHomerooms(grade) {
            if (grade) {
                try {

                    const { data } = await this.$apollo.query({
                        query: gql`
                            query FetchHomerooms($school_id: String!, $grade: Int!) {
                                fetchHomerooms(school_id: $school_id, grade: $grade)
                            }
                        `,
                        variables: {
                            school_id: 'ATHS-' + this.school.val,
                            grade: parseInt(grade),
                        },
                        fetchPolicy: 'network-only',
                    });

                    this.homerooms = data.fetchHomerooms;

                } catch (error) {
                    console.log(error.message);
                }
            }
        },
        async fetchStudents(homeroom) {
            if (homeroom) {
                try {

                    const { data } = await this.$apollo.query({
                        query: gql`
                            query fetchStudents($school_id: String!, $grade: Int!, $homeroom: String!) {
                                fetchStudents(school_id: $school_id, grade: $grade, homeroom: $homeroom) {
                                    Student_ID
                                    Student_Name
                                }
                            }
                        `,
                        variables: {
                            school_id: 'ATHS-' + this.school.val,
                            grade: parseInt(this.grade.val),
                            homeroom: homeroom,
                        },
                        fetchPolicy: 'network-only',
                    });

                    this.students = data.fetchStudents.map(user => {
                        return {
                            fullname: user.Student_Name,
                            student_id: user.Student_ID,
                            is_selected: false,
                        };
                    });

                    if (this.mode == 'create') {
                        this.unSelectedCandidates = data.fetchStudents.map(user => {
                            return {
                                fullname: user.Student_Name,
                                student_id: user.Student_ID,
                                reason: "",
                            };
                        });
                    }

                    if (this.mode == 'edit' && this.markSelectedCandidates) {
                        this.students.forEach(student => {
                            const isSelected = this.selectedCandidates.some(candidate =>
                                candidate.student_id === student.student_id
                            );
                            student.is_selected = isSelected;
                        });

                    }

                } catch (error) {
                    console.log(error.message);
                }
            }
        },
        addCandidate(user) {

            const index = this.students.findIndex(item => item.student_id === user.student_id);

            if (index !== -1) {
                if (!this.students[index].is_selected) {
                    const selectedUser = {
                        student_id: user.student_id,
                        fullname: user.fullname,
                    };
                    this.selectedCandidates.push(selectedUser);
                    this.students[index].is_selected = true;

                    // remove it from unselected array
                    const unselectIndex = this.unSelectedCandidates.findIndex(item => item.student_id === user.student_id);
                    if (unselectIndex !== -1) {
                        this.unSelectedCandidates.splice(unselectIndex, 1);
                    }

                    this.selectedCandidatesIsValid = true;
                    this.selectedCandidatesIsValidMsg = "";

                }
            } else {
                console.log('User not found in students');
            }
        },
        removeCandidate(userId) {
            const index = this.selectedCandidates.findIndex(item => item.student_id == userId);
            if (index !== -1) {
                this.selectedCandidates.splice(index, 1);
                const studentIndex = this.students.findIndex(item => item.student_id == userId);
                if (studentIndex !== -1) {
                    this.students[studentIndex].is_selected = false;
                    const unSelectedUser = {
                        student_id: this.students[studentIndex].student_id,
                        fullname: this.students[studentIndex].fullname,
                        reason: "",
                    };
                    this.unSelectedCandidates.push(unSelectedUser);
                } else {
                    console.log('User not found in students');
                }
            } else {
                console.log('User not found in selectedCandidates');
            }
        },
        viewStudentProfile(studentId) {
           this.$emit('view-student-profile', studentId);
        },
        selectAllStudents() {
            this.selectedCandidates = [];
            this.selectedCandidates = this.students.map(student => ({
                student_id: student.student_id,
                fullname: student.fullname
            }));
            this.unSelectedCandidates = [];
            this.students.forEach(student => {
                student.is_selected = true;
            });
            this.isSelectAllBtnClicked = true;
        },
        unselectAllStudents() {
            this.students.forEach(student => {
                student.is_selected = false;
            });
            this.selectedCandidates = [];
            this.unSelectedCandidates = [];
            this.unSelectedCandidates = this.students.map(student => ({
                student_id: student.student_id,
                fullname: student.fullname,
                reason: "",
            }));
            this.isSelectAllBtnClicked = false;
        },
        async onTrainingEntityChange() {
            const selectedPartner = await this.getAllPartners.find(partner => partner.id === this.trainingEntity.val);
            if (selectedPartner) {
                this.trainingEntityName = selectedPartner.en_company_name;
                this.sector.val = selectedPartner.entity_industry;
                this.location.val = selectedPartner.city;
                this.trade_license_authority.val = selectedPartner.trade_license_authority;
                this.trade_license_number.val = selectedPartner.trade_license_number;
            } else {
                this.trainingEntityName = '';
                this.sector.val = '';
                this.location.val = '';
                this.trade_license_authority.val = '';
                this.trade_license_number.val = '';
            }
        },
        getDisabledDates(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            // Check if the date is before today or more than a week from today
            if (date < today) {
                return true;
            }

            // Check if the date falls within the terms
            for (const term of this.getAcademicYearTerms) {
                let startDate = new Date(term.term_start_date);

                // Subtract one day
                startDate.setDate(startDate.getDate() - 1);

                let endDate = new Date(term.term_end_date);
                if (date >= startDate && date <= endDate) {
                    return true;
                }

            }

            // If none of the conditions match, the date is not disabled
            return false;
        },
    },
}
</script>

<style lang="scss" scoped>
label {
  @apply mb-1 block text-sm;
}
.form-input {
    input[type="text"],
    input[type="email"],
    input[type="number"],
    input[type="password"],
    input[type="date"],
    input[type="datetime-local"],
    select {
    @apply block w-full border rounded-lg py-2 px-2;
    }
    input[type="text"]:focus,
    input[type="email"]:focus,
    input[type="number"]:focus,
    input[type="password"]:focus,
    input[type="date"]:focus,
    input[type="datetime-local"]:focus,
    select:focus {
    outline: none;
    border-color: #394867;
    box-shadow: 0 0 0 2px #394867;
    }
}
.invalid label {
  @apply text-red-600;
}
.invalid input,
.invalid select {
  border: 1px solid red;
}
input[type="checkbox"] {
  @apply w-auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  height: 0px;
}
.max-ht-224 {
    max-height: 224px;
}
.ht-42 {
    height: 42px;
}
.mx-datepicker {
    width: 100%;
}
.rsdfade-enter-active,
.rsdfade-leave-active {
  transition: all 0.3s ease;
}
.rsdfade-enter-from,
.rsdfade-leave-to {
  opacity: 0;
}
</style>

<style lang="scss">
.mx-input {
    height: 42px !important;
    border-color: rgba(229, 231, 235, 1) !important;
    &:focus {
        border-color: #394867;
        box-shadow: 0 0 0 2px #394867;
    }
}
</style>